/**
 * Navigation
 * JS components for navigation
 */

const Nav = {};

Nav.nav = function () {
  var navEl = document.querySelector('#ms-nav');
  navEl.classList.add('is-initialized');
  var navSwitchEl = document.querySelector('#ms-nav-switch');
  navSwitchEl.addEventListener('click', function (e) {
    document.documentElement.classList.toggle('is-menu-open');
    e.preventDefault();
  });
};

// <select> navigation

Nav.selectNav = function (selector) {
  selector = selector || 'select';
  var selectEl = document.querySelector(selector);
  selectEl.selectedIndex = 0;
  selectEl.addEventListener('change', function (e) {
    if (selectEl.value[0] === 'h' || selectEl.value[0] === '/')
      location.replace(e.target.value);
    else if (selectEl.value[0] === '#')
      location.hash = selectEl.value;
  });
};

export default Nav;



// WEBPACK FOOTER //
// ./components/_nav.js